import React from "react";
import Header from "../LandingPage/Header";
import Contact from "./Contact";
import Footer from "../LandingPage/Footer";
import "../../landing.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function RequestDataDelete() {
  return (
    <div className="site-wrap">
      <Header />
      <Contact />
      <Footer />
    </div>
  );
}
